module.exports = __webpack_public_path__ + "images/renovation-icon-3f48ae5d68263ca1b123feba068167ae.svg";